import React from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { Input } from "@revvsales/components";
import { RevvForm, ErrorMessages } from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
} = DocumentTemplateActions;

class AddressField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDefaultValue: this._getShowDefaultValue(props),
      addressFieldValues: this._getDataForPrepopulate(props),
    };
  }

  _getShowDefaultValue = propsData => {
    let returnData = false;
    if (
      propsData.meta &&
      propsData.meta.default &&
      propsData.meta.default.addressLineOne !== ""
    ) {
      returnData = true;
    }
    return returnData;
  };

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.ADDRESS),
    );
    if (propsData.meta && propsData.meta.default) {
      returnData = propsData.meta.default;
    }
    return returnData;
  };

  _toggleDefaultValue = () => {
    const { showDefaultValue } = this.state;
    this.setState({ showDefaultValue: !showDefaultValue });
    this.props.setFlagForDefault(!showDefaultValue);
  };

  render() {
    const { showDefaultValue, addressFieldValues } = this.state;
    return (
      <React.Fragment>
        <Input
          id="checkbox"
          type="checkbox"
          data-test="AddressField-checkbox"
          checked={showDefaultValue}
          onChange={() => this._toggleDefaultValue()}
          className="dynamicfieldcustom-footer-input errorborder"
        />
        <span
          className="dynamicfieldcustom-footer-checkboxinput"
          data-test="addressfield-dynamicfieldcustom-footer-checkboxinput-defaultvalue">
          This has a default value
        </span>
        {showDefaultValue && (
          <RevvForm
            initialFormValue={addressFieldValues}
            customFieldName="ADDRESS"
            validateOnChange
            customFieldComponentRules={CustomFieldComponentRules}
            customFieldComponentMessages={CustomFieldComponentMessages}
            render={formProps => {
              const {
                handleChange,
                handleBlur,
                messages,
                touched,
                errors,
                values,
                isValid,
              } = formProps;
              const allInAll = {
                isValid,
                messages,
                touched,
                errors,
                values,
              };
              console.debug("allInAll", allInAll);
              if (isValid) {
                this.props.metaValidStatus(true);
                this.props.setMetaFieldValues(values);
              } else {
                this.props.metaValidStatus(false);
                this.props.setMetaFieldValues({});
              }
              return (
                <React.Fragment>
                  <div
                    className="dynamicfieldcustom-revvform"
                    data-test="addressfield-dynamicfieldcustom-revvform">
                    <div
                      className="revv-form-items"
                      data-test="addressfield-revv-form-items-addressline1">
                      <span
                        className="revvform-label"
                        data-test="addressfield-revvform-label-addressline1">
                        Address line one
                        <span
                          className="requiredwitherr-input"
                          data-test="addressfield-requiredwitherr-input-addressline1">
                          {" "}
                          *
                        </span>
                      </span>
                      <Input
                        autoFocus
                        id="addressLineOne"
                        data-test="addressfield-addressline1-input"
                        name="addressLineOne"
                        type="text"
                        value={values.addressLineOne}
                        placeholder="Address line one"
                        className={`${
                          messages.addressLineOne !== undefined &&
                          messages.addressLineOne.required !== ""
                            ? "danger-border"
                            : ""
                        }`}
                        onChange={value => handleChange(value)}
                        onBlur={value => handleBlur(value)}
                        required
                      />
                      {messages.addressLineOne && (
                        <ErrorMessages
                          messages={messages.addressLineOne.required}
                        />
                      )}
                    </div>
                    <div
                      className="revv-form-items"
                      data-test="addressfield-revv-form-items-addressline2">
                      <span
                        className="revvform-label"
                        data-test="addressfield-revvform-label-addressline2">
                        Address line two
                      </span>
                      <Input
                        id="addressLineTwo"
                        data-test="addressfield-addressline2-input"
                        type="text"
                        name="addressLineTwo"
                        value={values.addressLineTwo}
                        placeholder="Address line two"
                        onChange={value => handleChange(value)}
                        onBlur={value => handleBlur(value)}
                      />
                    </div>
                    <div
                      className="revv-form-items"
                      data-test="addressfield-revv-form-items-city">
                      <span
                        className="revvform-label"
                        data-test="addressfield-revvform-label-city">
                        City{" "}
                        <span
                          className="requiredwitherr-input"
                          data-test="addressfield-requiredwitherr-input-city">
                          *
                        </span>
                      </span>
                      <Input
                        id="city"
                        data-test="addressfield-city-input"
                        type="text"
                        name="city"
                        placeholder="City"
                        value={values.city}
                        className={`${
                          messages.city !== undefined &&
                          messages.city.required !== ""
                            ? "danger-border"
                            : ""
                        }`}
                        onChange={value => handleChange(value)}
                        onBlur={value => handleBlur(value)}
                        required
                      />
                      {messages.city && (
                        <ErrorMessages messages={messages.city.required} />
                      )}
                    </div>
                    <div
                      className="revv-form-items"
                      data-test="addressfield-revv-form-items-state">
                      <span
                        className="revvform-label"
                        data-test="addressfield-revvform-label-state">
                        State{" "}
                        <span
                          className="requiredwitherr-input"
                          data-test="addressfield-requiredwitherr-input-state">
                          *
                        </span>
                      </span>
                      <Input
                        id="state"
                        data-test="addressfield-state-input"
                        type="text"
                        name="state"
                        value={values.state}
                        placeholder="State"
                        className={`${
                          messages.state !== undefined &&
                          messages.state.required !== ""
                            ? "danger-border"
                            : ""
                        }`}
                        onChange={value => handleChange(value)}
                        onBlur={value => handleBlur(value)}
                        required
                      />
                      {messages.state && (
                        <ErrorMessages messages={messages.state.required} />
                      )}
                    </div>
                    <div
                      className="revv-form-items"
                      data-test="addressfield-revv-form-items-country">
                      <span
                        className="revvform-label"
                        data-test="addressfield-revvform-label-country">
                        Country
                      </span>
                      <Input
                        id="country"
                        data-test="addressfield-country-input"
                        type="text"
                        name="country"
                        value={values.country}
                        placeholder="Country"
                        className="dynamicfieldcustom-footer-input errorborder"
                        onChange={value => handleChange(value)}
                        onBlur={value => handleBlur(value)}
                      />
                    </div>
                    <div
                      className="revv-form-items"
                      data-test="addressfield-revv-form-items-zip">
                      <span
                        className="revvform-label"
                        data-test="addressfield-revvform-label-zip">
                        Zip code{" "}
                        <span
                          className="requiredwitherr-input"
                          data-test="addressfield-requiredwitherr-input-zip">
                          *
                        </span>
                      </span>
                      <Input
                        id="zip"
                        data-test="addressfield-zip-input"
                        name="zip"
                        type="number"
                        value={values.zip}
                        placeholder="Zip code"
                        className={`${
                          messages.zip !== undefined &&
                          messages.zip.required !== ""
                            ? "danger-border"
                            : ""
                        }`}
                        onChange={value => handleChange(value)}
                        onBlur={value => handleBlur(value)}
                        required
                      />
                      {messages.zip && (
                        <ErrorMessages messages={messages.zip.required} />
                      )}
                    </div>
                    {/* <JSONPretty id="json-pretty" data={allInAll} /> */}
                  </div>
                </React.Fragment>
              );
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddressField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/AddressField.js